/**
 * A tool for finding the bounding box around a set of colored pixels
 */
import { IBoundingBox } from "../app/videoplayer/model/IBoundingBox";

export class BoundingBoxScan {
  public static SCAN_OFFSET_RED: number = 0;
  public static SCAN_OFFSET_GREEN: number = 1;
  public static SCAN_OFFSET_BLUE: number = 2;
  public static SCAN_OFFSET_ALPHA: number = 3;

  public fastScanForTransparentFrame(d: Uint8ClampedArray, w: number, h: number): boolean {
    const BLOCK_SIZE = Math.ceil(w/10);
    let x: number;
    let y: number;
    let ptr: number;
    for (x = 0; x < w; x += BLOCK_SIZE) {
      for (y = 0; y < h; y += BLOCK_SIZE) {
        ptr = (x + (y * w)) * 4;
        if (d[ptr + BoundingBoxScan.SCAN_OFFSET_ALPHA] > 10) {
          return false;
        }
      }
    }
    return true;
  }

  /**
   * Scan the entire image for a rectangle in the red channel
   */
  public scan(d: Uint8ClampedArray, w: number, h: number, scanOffset: number = BoundingBoxScan.SCAN_OFFSET_RED): IBoundingBox {
    let x: number;
    let y: number;
    let ptr: number;
    const output: IBoundingBox = {
      x: 0,
      y: 0,
      right: 0,
      bottom: 0,
    }
    for (x = 0; x < w; x += 1) {
      for (y = 0; y < h; y += 1) {
        ptr = (x + (y * w)) * 4;
        // Check if channel is 'full' red. Do not check for 0xFF because JPEG compression messes up pure colors
        if (d[ptr + scanOffset] > 250) {
          if (output.x === 0){
            output.x = x;
          }
          if (output.y === 0){
            output.y = y;
          } else {
            output.y = Math.min(y, output.y);
          }
          output.right = Math.max(output.right, x);
          output.bottom = Math.max(output.bottom, y);
        }
      }
    }
    return output;
  }

}
